import $ from 'jquery';
import _ from 'underscore';
import MessageBox from '../../layout/MessageBox';
import Step1Controller from '../../pages/fttc2/Step1Controller';
import { register } from '../../core/bootstrapper';
import Step1Model from '../../pages/fttc2/Step1Model';
import Step1OrdersListView from '../../pages/fttc2/Step1OrdersListView';
import Step1UploadView from '../../pages/fttc2/Step1UploadView';
import Step2ArticleView from '../../pages/fttc2/Step2ArticleView';
import Step2CommentView from '../../pages/fttc2/Step2CommentView';
import Step2Controller from '../../pages/fttc2/Step2Controller';
import Step2Model from '../../pages/fttc2/Step2Model';
import Step3Controller from '../../pages/fttc2/Step3Controller';
import StepsView from '../../pages/fttc2/StepsView';

let messageBox;
let step1Model;
let step1UploadView;
let step1OrdersList;
let step1Controller;

const step2ArticleView = [];
let step2Model;
let step2CommentView;
let step2Controller;

register('myaccount', function() {
  var $fttc2Content = $('#fttc2-wrapper');
  var $uploadTemplate = $('#upload-file-template');

  if ($fttc2Content.length > 0) {
    messageBox = new MessageBox($('.messages'));

    switch ($fttc2Content.data('step')) {
      case 1:
        step1Model = new Step1Model();

        step1UploadView = new Step1UploadView({
          el: $('.js-upload-section'),
          model: step1Model,
          $uploadTemplate: $uploadTemplate,
          messageBox: messageBox
        });

        step1OrdersList = new Step1OrdersListView({
          el: $('.js-order-list'),
          model: step1Model
        });

        step1Controller = new Step1Controller({
          el: $('.fttc2-button-holder'),
          model: step1Model,
          orderList: step1OrdersList,
          uploadView: step1UploadView,
          messageBox
        });

        break;

      case 2:
        step2Model = new Step2Model();

        var $popup = $('#upload-dialog');

        step2CommentView = new Step2CommentView({
          el: $('.fttc2-textarea-holder'),
          model: step2Model
        });

        _.each($('.fttc2-section.reason-parent'), function(el) {
          step2ArticleView.push(
            new Step2ArticleView({
              el: el,
              model: step2Model,
              commentView: step2CommentView,
              $popup: $popup,
              $uploadTemplate: $uploadTemplate,
              messageBox
            })
          );
        });

        _.each(step2ArticleView, function(view) {
          view.preselect();
        });

        /*
                 initialize main form controller
                 */
        step2Controller = new Step2Controller({
          el: $('#reasonForm'),
          model: step2Model,
          articleViews: step2ArticleView,
          commentView: step2CommentView,
          messageBox
        });

        break;

      case 3:
        var $fttc2BankDetailsForm = $('.fttc2-bank-details-form');

        if ($fttc2BankDetailsForm.length) {
          new Step3Controller({
            el: $fttc2BankDetailsForm
          });
        }
        break;
    }

    new StepsView({
      el: $('.checkout-steps'),
      step: $fttc2Content.data('step'),
      step1Controller,
      step2Controller
    });
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/fttc2Bootstrap.js
 **/